import { tenantService } from "../../../../services/tenantService";
import LogoUploader, { S3Params } from "../../../../components/LogoUploader";
import React, { useEffect, useState } from "react";
import { Button } from '../../../../components/ui/Button';
import { Checkbox, TextField } from '../../../../components/ui/Field';
import { Surface } from '../../../../components/ui/Surface';

interface SettingsTabProps {
  tenant: any;
  refetch: () => void;
}

const SettingsTab: React.FC<SettingsTabProps> = ({ tenant, refetch }) => {
    const [dataTobeUpdated, setDataTobeUpdated] = useState<{
        name: string;
        isWhitelabeled: boolean;
        s3LogoObjectData: S3Params | null;
        s3FaviconObjectData: S3Params | null;
    }>({
        name: tenant?.name || "",
        isWhitelabeled: Boolean(tenant?.isWhitelabeled),
        s3LogoObjectData: tenant?.s3LogoObjectData,
        s3FaviconObjectData: tenant?.s3FaviconObjectData 
    });
    const [loading, setLoading] = useState(false);

  const update = async () => {
    try {
        setLoading(true);
        await tenantService.update(tenant.id, dataTobeUpdated);
        // Turning whitelabel on reveals the Branding and Domains tabs, so the
        // parent has to reload for them to appear.
        refetch();
    } catch (err) {
        console.error("Failed to update tenant", err);
    } finally {
        setLoading(false);
    }
    };

  useEffect(()=>{
    console.log("tenant in settings tab==>",tenant)
  },[tenant])

  return (
    <div className="space-y-10">

      {/* Header */}
      <h2 className="text-xl font-semibold">Tenant Settings</h2>

      {/* Tenant Name */}
      <div className="bg-gray-50 border rounded-xl p-6 flex flex-col gap-3">
        <label className="text-sm font-medium text-gray-700">Tenant Name</label>
        <TextField
          type="text"
          value={dataTobeUpdated.name}
          onChange={(e) => setDataTobeUpdated({ ...dataTobeUpdated, name: e.target.value })}
          placeholder="Enter tenant name"
          className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />
      </div>



      {/* WHITELABEL */}
      <div className="bg-gray-50 border rounded-xl p-6 flex flex-col gap-3">
        <label className="flex items-center gap-3">
          <Checkbox
           
            checked={dataTobeUpdated.isWhitelabeled}
            onChange={(e) => setDataTobeUpdated({ ...dataTobeUpdated, isWhitelabeled: e.target.checked })}
            className="h-4 w-4"
          />
          <span className="text-sm font-medium text-gray-700">Whitelabel tenant</span>
        </label>
        <p className="text-xs text-gray-500">
          Enables the Branding and Domains tabs, and requires this tenant to supply its own
          Twilio and speech credentials on the agent's Voice tab. When off, the tenant uses the
          platform's global configuration for everything.
        </p>
      </div>

      {/* FAVICON SECTION */}
      <Surface tone="plain" className="border rounded-xl p-6">
            <LogoUploader
                label="Upload Icon"
                value={dataTobeUpdated.s3LogoObjectData}
                onChange={(url) => {
                  setDataTobeUpdated({ ...dataTobeUpdated, s3LogoObjectData: url });
                }}
            />
      </Surface>
      <Surface tone="plain" className="border rounded-xl p-6">

            <LogoUploader
                label="Upload Favicon"
                value={dataTobeUpdated.s3FaviconObjectData}
                onChange={(url) => {
                  setDataTobeUpdated({ ...dataTobeUpdated, s3FaviconObjectData: url });
                }}
                />
      </Surface>

      {/* SAVE BUTTON */}
      <div className="flex justify-end pt-4">
        <Button tone="blue"
          onClick={update}
          className="px-6 py-2 rounded-lg transition"
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};

export default SettingsTab;
